export default class VariantSelector extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this._product = this.context.product;
    this._selectedVariant = this._product
      ? this._product.variants.find(v => v.id.toString() === this.context.selected_variant)
      : null;

    const mainInputEl = this.el.querySelector('input[data-variants]');
    this._mainEl = mainInputEl || this.el.querySelector('select[data-variants]');
    this.events.register(this._mainEl, 'change', event => this._onMainElChange(event));
  }

  get product() {
    return this._product;
  }

  get selectedVariant() {
    return this._selectedVariant;
  }

  onMount() {
    this.events.register(this.parent.el, 'product:options-change', event => this._onVariantChange(event));
  }

  _onVariantChange(event) {
    const { variant, state } = event.detail;
    const cancelled = !this._dispatchEvent(variant, state);

    if (!cancelled) {
      this._selectedVariant = variant;
      this._mainEl.value = variant.id;
    }

    return cancelled;
  }

  _onMainElChange(event) {
    const { value: variantId } = event.currentTarget;
    const variant = this._product.variants
      .find(v => v.id.toString() === variantId.toString());
    const cancelled = this._onVariantChange({ detail: { variant, state: variant ? 'unavailable' : 'unselected' } });

    if (cancelled) {
      event.preventDefault();
    }
  }

  _dispatchEvent(variant, state) {
    const event = new CustomEvent('product:variant-change', {
      bubbles: true,
      cancelable: true,
      detail: {
        product: this._product,
        variant,
        state,
      },
    });

    return this.el.dispatchEvent(event);
  }
}
